import type { ClaimGalaV1Hook } from './types/claimGala.type';
import { BaseHookResult, createVersionedHook } from './utils/createVersionHooks';
import { useClaimGalaV1 } from './v1';

interface UseClaimGala extends ClaimGalaV1Hook, BaseHookResult {}

export const useClaimGala = createVersionedHook<UseClaimGala>(
  {
    v1: useClaimGalaV1,
    v2: () => {
      throw new Error('Not implemented');
    },
  },
  'useClaimGala',
);
